/*
 * Ring and ringback, made with WebAudio so there is no sound file to ship or
 * fail to load. Both stop the moment the call moves on.
 */
let ctx = null;
let timer = null;
let nodes = [];
function context() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
}
function burst(freqs, seconds, volume) {
  const c = context();
  const gain = c.createGain();
  gain.gain.setValueAtTime(0, c.currentTime);
  gain.gain.linearRampToValueAtTime(volume, c.currentTime + 0.02);
  gain.gain.setValueAtTime(volume, c.currentTime + seconds - 0.05);
  gain.gain.linearRampToValueAtTime(0, c.currentTime + seconds);
  gain.connect(c.destination);
  freqs.forEach(f => {
    const o = c.createOscillator();
    o.frequency.value = f;
    o.connect(gain);
    o.start();
    o.stop(c.currentTime + seconds);
    nodes.push(o);
  });
}
export function ring() {
  stop();
  const play = () => {
    burst([660, 880], 0.35, 0.12);
    setTimeout(() => burst([660, 880], 0.35, 0.12), 450);
  };
  play();
  timer = setInterval(play, 2500);
}
export function ringback() {
  stop();
  const play = () => burst([440, 480], 1.6, 0.06);
  play();
  timer = setInterval(play, 4000);
}
export function stop() {
  clearInterval(timer);
  timer = null;
  nodes.forEach(n => {
    try {
      n.stop();
    } catch (e) {
      // Already stopped.
    }
  });
  nodes = [];
}